import { render, staticRenderFns } from "./Mask.vue?vue&type=template&id=8d09f652&scoped=true&"
import script from "./Mask.vue?vue&type=script&lang=ts&"
export * from "./Mask.vue?vue&type=script&lang=ts&"
import style0 from "./Mask.vue?vue&type=style&index=0&id=8d09f652&prod&lang=scss&scoped=true&"
import style1 from "./Mask.vue?vue&type=style&index=1&id=8d09f652&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d09f652",
  null
  
)

export default component.exports